import { Alert, CloseButton, Link, Text, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'next-i18next';

import { apos } from 'lib/html-entities';

function ChartsLoadingErrorAlert() {
  const {
    isOpen: isVisible,
    onClose,
  } = useDisclosure({ defaultIsOpen: true });
  const { t } = useTranslation('common');

  return isVisible ? (
    <Alert status="warning" mb={ 4 }>
      <Text mr={ 2 }>
        { t('ChartsLoadingErrorAlert.error', { apos }) }
        <Link href={ window.document.location.href }>{ t('ChartsLoadingErrorAlert.retry') }</Link>
      </Text>

      <CloseButton
        alignSelf={{ base: 'flex-start', lg: 'center' }}
        ml="auto"
        onClick={ onClose }
      />
    </Alert>
  ) : null;
}

export default ChartsLoadingErrorAlert;
